<!--
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-03-28 12:17:11
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-01 17:19:56
 * @FilePath: \newmall\src\layout\TabbarLayout\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <router-view />
    <!-- <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
    ></router-view> -->
    <layout-tabbar :tab-list="tabbarList"></layout-tabbar>
  </div>
</template>
<script>
import tabbar from '@/router/routes/tabbarRoute.js'
import layoutTabbar from '@/components/Tabbar.vue'
import configColor from '@/config/color.config'
export default {
  name: 'Tabbar',
  components: {
    layoutTabbar
  },
  data() {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      configColor
    }
  },
  computed: {
    tabbarList() {
      const list = tabbar[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: item.meta.icon
        }
      })
      return list
    }
  }
}
</script>
<style lang="scss" scoped></style>
